// Hardcode for 301 redirect，用在兩種情況：
//   1. pages/_app.js 的 MyApp.getInitialProps —— per-request SSR 頁面命中 themeState === 'NOT_FOUND' 時 server 端 301。
//   2. src/components/AppBackground.js 的 NOT_FOUND 處理 —— SSG 頁面（如 /hr）沒走 SSR，只能在 client 端 window.location.replace。
// key 是含 protocol 的完整 origin（對到 `https://${host}`），value 是要導去的完整 URL。
const redirectConfigs = {
	// source: target
	'https://abc.staging.teaches.cc': 'https://yaoyan.staging.teaches.cc',
	'https://brightsidetw.teaches.cc': 'https://ucasalon-learningcenter.teaches.cc',
};

// 命中 redirectConfigs 就用對應 target，否則 fallback 到打卡之星官網。
export const resolveRedirectTarget = origin => redirectConfigs[origin] || 'https://www.dakastar.com.tw';

export default redirectConfigs;
